import tailwindColors from 'tailwindcss/colors'

import { tenantPalettes } from './tenant-palettes'

export const tenant = 'swedavia' as const

export const tenantColors = tenantPalettes.swedavia

// tailwindColors stays spread so existing colors['blue'][500] call sites resolve.
export const colors = { ...tailwindColors, ...tenantColors }
